import { LoginForm } from '@/features/login/components/LoginForm'

const LoginPage = () => {
  return <LoginForm />
}

export default LoginPage
